import { render, staticRenderFns } from "./PaymentStatusView.vue?vue&type=template&id=7e2fa170"
import script from "./PaymentStatusView.vue?vue&type=script&lang=js"
export * from "./PaymentStatusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports